(function () {
    'use strict';

    // Populates [data-product-badge] slots rendered empty by snippets/product-badges.liquid.
    // Fetches the winning badge from the metasync endpoint, which filters out
    // draft/inactive bundle badges and applies the same priority rules as the
    // Klevu feed so the PDP stays in sync with the rest of the site.

    var ENDPOINT = 'https://etempashopifyapps-server-b.co.uk/rarewaves-metasync/endpoints/get_product_badge.php';

    function parseTags(raw) {
        if (!raw) return [];
        return raw.split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    }

    // The endpoint returns badge_text with HTML entities encoded (e.g. "&pound;").
    // Decode via a textarea so entities resolve without executing any HTML.
    function decodeEntities(str) {
        var ta = document.createElement('textarea');
        ta.innerHTML = str;
        return ta.value;
    }

    function renderBadge(slot, badge) {
        if (!badge || !badge.badge_text) {
            // No winning badge — clear the server-rendered fallback.
            slot.innerHTML = '';
            return;
        }

        var format = slot.getAttribute('data-badge-format') || 'right-small';
        var bg = badge.tag_background_colour || '';
        var fg = badge.tag_text_colour || '';
        var style = '--colour-custom-badge-background:' + bg + ';' +
                    (fg ? ' --colour-custom-badge-foreground:' + fg + ';' : '');

        var tagEl;
        if (badge.tag_collection_link) {
            tagEl = document.createElement('a');
            tagEl.setAttribute('href', badge.tag_collection_link);
        } else {
            tagEl = document.createElement('span');
        }

        tagEl.className = 'badge badge-custom product_badge badge-format-' + format;
        tagEl.setAttribute('style', style);

        var textEl = document.createElement('span');
        textEl.className = 'badge-text';
        textEl.textContent = decodeEntities(badge.badge_text);
        tagEl.appendChild(textEl);

        slot.innerHTML = '';
        slot.appendChild(tagEl);
    }

    var cache = {};

    function load(slot) {
        var tags = parseTags(slot.getAttribute('data-product-tags'));

        if (tags.length === 0) {
            slot.innerHTML = '';
            slot.dataset.badgeLoaded = 'true';
            return;
        }

        // Dedupe concurrent requests for identical tag sets (e.g. same product
        // rendered multiple times on one page).
        var key = tags.slice().sort().join('|');

        if (!cache[key]) {
            cache[key] = fetch(ENDPOINT, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ tags: tags })
            })
            .then(function (response) {
                if (!response.ok) throw new Error('Badge endpoint returned ' + response.status);
                return response.json();
            })
            .then(function (data) { return data && data.badge ? data.badge : null; })
            .catch(function (err) {
                delete cache[key]; // Evict bad entry so future loads can retry
                return null;       // Resolve with null so per-slot chains don't throw
            });
        }

        cache[key].then(function (badge) {
            renderBadge(slot, badge);
            slot.dataset.badgeLoaded = 'true';
        });
    }

    function init() {
        var slots = document.querySelectorAll('[data-product-badge]:not([data-badge-loaded])');
        if (slots.length === 0) return;

        slots.forEach(function (slot) { load(slot); });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Re-run after dynamic content loads (e.g. AJAX-added recommended products,
    // quick-view modals). Themes commonly fire custom events for this; harmless
    // if no listener triggers them.
    document.addEventListener('product-badges:refresh', init);
})();
